<app-pias-layout>
    <div pias-layout-content>
        @if(this.setSprinner()) {
        <div class="pias-spinner">
            <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        }
        <div id="edit-onboarding-application-container" class="container-fluid">
            <div id="edit-onboarding-application-header" class="d-flex justify-content-between">
                <h5 class="page-header">Agent Onboarding</h5>
            </div>

            <mat-card appearance="raised" class="pias-card">
                <mat-card-content class="pias-card-content">
                    <form class="row align-items-start" [formGroup]="editOnboardApplicationFg">
                         <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Who are you onboarding?</mat-label>
                            <mat-form-field class="w-100">
                                <mat-select formControlName="designation" placeholder="Select Designation" required>
                                    @for(designation of this.designations; track designation) {
                                    <mat-option value="{{designation.value}}">{{designation.name}}</mat-option>
                                    }
                                </mat-select>
                                @if(this.editOnboardApplicationFg.controls["designation"].invalid
                                && (this.editOnboardApplicationFg.controls["designation"].touched ||
                                this.editOnboardApplicationFg.controls["designation"].dirty)
                                ) {
                                <mat-error>
                                    @if(this.editOnboardApplicationFg.controls["designation"].errors?.["required"])
                                    {
                                    <span>Designation is required.</span>
                                    }
                                    @else {
                                    <span></span>
                                    }
                                </mat-error>
                                }
                            </mat-form-field>
                        </p>
                        @if (showFields) {
                        <!-- <div class="form-section-title">Personal Information</div> -->
                        @if (showName) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Name (As per NRIC)</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="name" placeholder="Enter Name (As per NRIC)"
                                    type="text" required />
                                @if(this.editOnboardApplicationFg.controls["name"].invalid
                                && (this.editOnboardApplicationFg.controls["name"].touched ||
                                this.editOnboardApplicationFg.controls["name"].dirty)
                                ) {
                                <mat-error>
                                    @if(this.editOnboardApplicationFg.controls["name"].errors?.["required"]) {
                                    <span>Name is required.</span>
                                    }
                                    @else {
                                    <span></span>
                                    }
                                </mat-error>
                                }
                            </mat-form-field>
                        </p>
                        }
                        @if (showCompany) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Name Of Company</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="companyName" placeholder="Enter Company Name"
                                    type="text" required />
                                @if(this.editOnboardApplicationFg.controls["companyName"].invalid
                                && (this.editOnboardApplicationFg.controls["companyName"].touched ||
                                this.editOnboardApplicationFg.controls["companyName"].dirty)
                                ) {
                                <mat-error>
                                    @if(this.editOnboardApplicationFg.controls["companyName"].errors?.["required"]) {
                                    <span>Company Name is required.</span>
                                    }
                                    @else {
                                    <span></span>
                                    }
                                </mat-error>
                                }
                            </mat-form-field>
                        </p>
                        }
                        @if (showPreferredName) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Preferred Name</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="preferredName" placeholder="Enter PreferredName"
                                    type="text" />
                            </mat-form-field>
                        </p>
                        }
                        @if (showBranch) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Branch</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="branch" readonly placeholder="Branch" value="Branch"
                                    type="text" />
                            </mat-form-field>
                        </p>
                        }
                        @if (showDirector) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Financial Services Director</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="financialServicesDirector" readonly
                                    placeholder="Financial Services Director" type="text"
                                    value="Financial Services Director" />
                            </mat-form-field>
                        </p>
                        }
                        @if (showManager) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Financial Services Manager</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="financialServicesManager"
                                    placeholder="Financial Services Manager" value="Financial Services Manager" readonly
                                    type="text" />
                            </mat-form-field>
                        </p>
                        }
                        @if (showEmail) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">{{ emailLabel }}</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="personalEmailAddress"
                                    placeholder="Enter {{ emailLabel }}" type="email" required />
                                @if(this.editOnboardApplicationFg.controls["personalEmailAddress"].invalid
                                && (this.editOnboardApplicationFg.controls["personalEmailAddress"].touched ||
                                this.editOnboardApplicationFg.controls["personalEmailAddress"].dirty)
                                ) {
                                <mat-error>
                                    @if(this.editOnboardApplicationFg.controls["personalEmailAddress"].errors?.["required"])
                                    {
                                    <span>{{ emailLabel }} is required.</span>
                                    }@else if
                                    (this.editOnboardApplicationFg.controls["personalEmailAddress"].errors?.["email"])
                                    {
                                    <span>Invalid {{ emailLabel }}.</span>
                                    }
                                    @else {
                                    <span></span>
                                    }
                                </mat-error>
                                }
                            </mat-form-field>
                        </p>
                        }
                        @if (showReferral) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Name of Referral</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="nameofReferral" placeholder="Enter Name of Referral"
                                    type="text" />
                            </mat-form-field>
                        </p>
                        }
                        @if (showRemarks) {
                        <p class="col-sm-12 col-md-6 col-lg-6 col-xxl-6 m-0">
                            <mat-label class="field-label">Remarks</mat-label>
                            <mat-form-field class="w-100">
                                <input matInput formControlName="remarksbyRecruitmentManager"
                                    placeholder="Enter Remarks" type="text" />
                            </mat-form-field>
                        </p>
                        }
                        }

                        <mat-divider class="pias-divider"></mat-divider>

                        <div class="row">
                            <div class="col-12 d-flex justify-content-between">

                                <!-- Cancel -->
                                <button type="button" class="btn btn-cancel btn-lg" [routerLink]="'/agent-onboarding'">
                                    Cancel
                                </button>

                                <!-- Save & Send -->
                                <div>

                                    <button type="button" class="btn btn-submit btn-lg me-2"
                                        [disabled]="this.disabled()" (click)="saveOnboardApplication()">
                                        Save
                                    </button>

                                    <button type="button" class="btn btn-submit btn-lg"
                                        [disabled]="this.editOnboardApplicationFg.invalid"
                                        (click)="this.openConfirmDialog()">
                                        Submit
                                    </button>
                                </div>

                            </div>
                        </div>
                    </form>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</app-pias-layout>